import ApplicationConfig from "../../../ApplicationConfig";
import * as apiHelper from "../../../helpers/apiHelpers";

export class MediaRepository {

  async fetchList(searchText, limit, offset) {
    var queryParams = '';
    queryParams += searchText != null ? 'search_tag=' + searchText + '&' : '';
    queryParams += limit != null ? 'limit=' + limit + '&' : '';
    queryParams += offset != null ? 'offset=' + offset + '&' : '';

    const response = await apiHelper.authenticatedFetch(
      ApplicationConfig.BACKEND_URL + '/media/list?' + queryParams,
      {}
    );

    const responseBody = await response.json();        
    return responseBody;
  }

  async uploadImage(base64Data, tags) {
    const postBody = {
      base64Data: base64Data,
      tags: tags,
    };

    const response = await apiHelper.authenticatedFetch(
      ApplicationConfig.BACKEND_URL + '/media/upload-image', 
      {                
        method: 'POST',
        body: JSON.stringify(postBody),
      }
    );

    const responseBody = await response.json();
    return responseBody;
  }

  async editMedia(mediaKey, tags) {
    const postBody = {
      key: mediaKey,
      tags: tags,
    };

    const response = await apiHelper.authenticatedFetch(
      ApplicationConfig.BACKEND_URL + '/media/edit', 
      {                
        method: 'POST',
        body: JSON.stringify(postBody),
      }
    );

    const responseBody = await response.json();
    return responseBody;
  }

}